var _path, _ellipse, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243,
    height: 108,
    viewBox: "0 0 243 108",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243 75.4426H233.088V99H213.631V75.4426H179V16H198.457V58.7206H213.631V37.2382H233.088V58.7206H243V75.4426Z",
    fill: "#E8ED87"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121,
    cy: 57.5,
    rx: 42,
    ry: 41.5,
    fill: "url(#paint0_linear_3420_13003)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 75.4426H54.088V99H34.631V75.4426H0V16H19.457V58.7206H34.631V37.2382H54.088V58.7206H64V75.4426Z",
    fill: "#D1D57A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 116,
    y: 27,
    width: 11,
    height: 14,
    fill: "url(#paint1_linear_3420_13003)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.235 75L106.303 81.4531L96 91.0036C98.7045 96.6823 107.591 107.059 121.5 103.135V75H108.235Z",
    fill: "url(#paint2_linear_3420_13003)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.765 75L136.697 81.4531L147 91.0036C144.295 96.6823 135.409 107.059 121.5 103.135V75H134.765Z",
    fill: "url(#paint3_linear_3420_13003)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122 107L120.08 98L110.48 99.9367L104.6 98L101 101.646L102.68 107H122Z",
    fill: "#E4B595"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.229 108L120 97.4155L149.467 80.6773C155.608 78.7081 159.124 81.4978 160.114 83.1388C162.689 87.8649 159.041 92.1643 156.895 93.7233L122.229 108Z",
    fill: "#32BFAF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120 107L121.92 98L131.52 99.9367L137.4 98L141 101.646L139.32 107H120Z",
    fill: "#FDC9A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.771 108L122 97.4155L92.5334 80.6773C86.3924 78.7081 82.8762 81.4978 81.8857 83.1388C79.3105 87.8649 82.9588 92.1643 85.1048 93.7233L119.771 108Z",
    fill: "#2DAC9E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.024 36L102.831 39.6842C101.089 40.1345 97.4545 42.214 96.8571 46.9298L92.0032 65.1053L75.948 75.1754L70.5963 73.3333L64 75.1754L66.6136 85L95.488 76.1579C96.5252 75.6667 98.7489 74.2421 99.3463 72.4737L106.067 58.7193L109.801 63.386V69.1579L107.809 75.1754H121.5V36H116.024Z",
    fill: "url(#paint4_linear_3420_13003)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.976 36L140.169 39.6842C141.911 40.1345 145.546 42.214 146.143 46.9298L150.997 65.1053L167.052 75.1754L172.404 73.3333L179 75.1754L176.386 85L147.512 76.1579C146.475 75.6667 144.251 74.2421 143.654 72.4737L136.933 58.7193L133.199 63.386V69.1579L135.191 75.1754H121.5V36H126.976Z",
    fill: "url(#paint5_linear_3420_13003)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.582 37L104.477 39.0967V48.2233C102.717 50.4844 101.088 56.7827 108.652 63.8867V70.1767L107.302 74H133.698L132.348 70.1767V63.8867C139.912 56.7827 138.283 50.4844 136.523 48.2233V39.0967L128.418 37V46.1267L120.5 51.7549L112.582 46.1267V37Z",
    fill: "url(#paint6_linear_3420_13003)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127 32.0623C125.072 33.8181 123.019 34.8182 121.5 35C119.981 34.8182 117.928 33.8181 116 32.0623V27H127V32.0623Z",
    fill: "black",
    fillOpacity: 0.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109.667 18.5882C109.667 13.2353 110.5 5.82353 120.5 5C130.5 5.82353 131.333 13.2353 131.333 18.5882C131.333 18.7264 131.332 18.8637 131.328 19H132.167C132.627 19 133 19.3687 133 19.8235V22.2941C133 22.7489 132.627 23.1176 132.167 23.1176H130.676C128.834 29.2063 123.558 32.6642 120.5 33C117.442 32.6642 112.166 29.2063 110.324 23.1176H108.833C108.373 23.1176 108 22.7489 108 22.2941V19.8235C108 19.3687 108.373 19 108.833 19H109.672C109.668 18.8637 109.667 18.7264 109.667 18.5882Z",
    fill: "url(#paint7_linear_3420_13003)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.286 26.6004C119.714 26.1473 120.657 25.513 121 26.6004C121.343 25.513 122.286 26.1473 122.714 26.6004L124 27.9596C123.023 30.0262 121.581 30.0061 121.072 29.999C121.045 29.9987 121.021 29.9983 121 29.9983C120.979 29.9983 120.955 29.9987 120.928 29.999C120.419 30.0061 118.977 30.0262 118 27.9596L119.286 26.6004Z",
    fill: "url(#paint8_linear_3420_13003)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M132 18.8363C124.747 20.4845 115.428 18.1496 112.113 15.3045L113.575 28.5488C107.96 32.787 103.145 30.6091 101 28.8431C102.404 28.8431 103.925 26.6848 104.509 25.6056C106.147 23.9575 106.557 20.406 106.557 18.8363C106.557 16.7173 108.506 11.9689 109.189 9.12385C111.762 1.58932 116.695 0 119.132 0C126.151 0 127.906 4.51287 127.906 7.65226C130.947 9.30044 131.903 12.8519 132 14.4216V18.8363Z",
    fill: "url(#paint9_linear_3420_13003)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3420_13003",
    x1: 163,
    y1: 57.5,
    x2: 79,
    y2: 57.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E8ED87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D1D57A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3420_13003",
    x1: 127,
    y1: 34,
    x2: 116,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDC9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E4B595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3420_13003",
    x1: 147,
    y1: 89.5,
    x2: 96,
    y2: 89.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#28998C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4951,
    stopColor: "#23867A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3420_13003",
    x1: 147,
    y1: 89.5,
    x2: 96,
    y2: 89.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#28998C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4951,
    stopColor: "#23867A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3420_13003",
    x1: 179,
    y1: 60.5,
    x2: 64,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDC9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E4B595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3420_13003",
    x1: 179,
    y1: 60.5,
    x2: 64,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDC9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E4B595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3420_13003",
    x1: 138,
    y1: 55.5,
    x2: 103,
    y2: 55.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8284C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5001,
    stopColor: "#C22444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3420_13003",
    x1: 108,
    y1: 19,
    x2: 133,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E4B595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FDC9A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3420_13003",
    x1: 118,
    y1: 28,
    x2: 124,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D8284C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#C22444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3420_13003",
    x1: 132,
    y1: 15.5,
    x2: 101,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#5E350C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#683B0D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.a7873bb7f140bdad0743f2f5e5bbfe6b.svg";
export { ForwardRef as ReactComponent };